import { connect } from 'react-redux'
import DeleteSkillView from './DeleteSkillView.jsx';
import { deleteSkill } from 'src/legacy/redux/actions/skills.jsx';


const mapStateToProps = (state, ownProps) => {
  return {
    skills: state.legacyRootReducer.settings.skills.items.records || [], 
    deleting: state.legacyRootReducer.settings.skills.deleting
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    deleteSkill: (id) => {
      return dispatch(deleteSkill(id));
  }

  }
}

const DeleteSkillContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteSkillView)

export default DeleteSkillContainer;